import React, { useEffect, useState } from 'react';
import NativeSelect from '@material-ui/core/NativeSelect';
import Box from '@material-ui/core/Box';

export type ComboBoxItemTypeS = {
  key: string;
  name: string;
  tag?: any;
};

type Props = {
  itemList: ComboBoxItemTypeS[] | undefined;
  label: string;
  value?: string;
  itemBoxStyle?: string;
  labelStyle?: string;
  onChangeEvent?: (event: React.ChangeEvent<{ name?: string; value: unknown }>) => void;
};

export const ItemComboBoxStr: React.FC<Props> = (props) => {
  return (
    <Box display="flex" justifyContent="flex-start" alignItems="center">
      <div className={props.labelStyle ?? ''}>{props.label}</div>
      <div>
        <NativeSelect onChange={props.onChangeEvent} className={props.itemBoxStyle ?? ''} value={props.value}>
          {props.itemList?.map((row, index) => (
            <option key={index} value={row.key}>{`${row.name}`}</option>
          ))}
        </NativeSelect>
      </div>
    </Box>
  );
};
export default ItemComboBoxStr;
